// test1248
(1248 && 0);
